// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCnyEH4KwK9D7dxsuPCivoCCPGNAYRuH5M",
  authDomain: "quizwall-publisher.firebaseapp.com",
  projectId: "quizwall-publisher",
  storageBucket: "quizwall-publisher.appspot.com",
  messagingSenderId: "1092865474677",
  appId: "1:1092865474677:web:4253a1e5316787a3e8f83c",
  measurementId: "G-9BM7WSK6HW"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);